// import { flatPickr } from 'vue-flatpickr-component';
import { App, h, Component, VNode } from 'vue'

import Controller from '@/components/control/ControlDescriptor.vue'
import InputLabel from './Label.vue'
import InputTextArea from './TextArea.vue'
import SimpleInput from './SimpleInput.vue'
import SimpleChecker from './SimpleChecker.vue'
import SimpleRadio from './SimpleRadio.vue'
import SimpleMultiselect from './Multiselect.vue'
import Multiselect from './MutiselectInput.vue'
import Recaptcha from '@/components/control/RecaptchaComponent.vue'
import Checker from './Checker'
import OtpInput from './OtpInput.vue'
import Image from './Image.vue'
import Autocomplete from './Autocomplete.vue'
import Flatpickr from './Flatpickr.vue'
import SimpleOutput from './SimpleOutput.vue'
import FakeInput from './FakeInput.vue'

export function hoc(WrappedComponent: Component, params: Record<string, unknown>): VNode {
  return h(WrappedComponent, {
    ...params,
  })
}

export const CCheckbox = hoc(Checker, { b: 'control-checkbox' })
export const CRadio = hoc(Checker, { b: 'control-radio' })
const register = (app: App<Element>): void => {
  const prefix = 'DControl'
  app
    .component(`${prefix}Autocomplete`, Autocomplete)
    .component(`${prefix}Input`, Controller)
    .component(`${prefix}Label`, InputLabel)
    .component(`${prefix}Textarea`, InputTextArea)
    .component(`${prefix}Checker`, SimpleChecker)
    .component(`${prefix}Radio`, SimpleRadio)
    .component(`${prefix}SimpleInput`, SimpleInput)
    .component(`${prefix}Recaptcha`, Recaptcha)
    .component(`${prefix}Multiselect`, Multiselect)
    .component(`${prefix}SimpleMultiselect`, SimpleMultiselect)
    .component(`${prefix}OtpInput`, OtpInput)
    .component(`${prefix}Image`, Image)
    .component(`${prefix}Flatpickr`, Flatpickr)
    .component(`${prefix}Output`, SimpleOutput)
    .component('FakeInput', FakeInput)
    .component('ControlCheckbox', CCheckbox)
    .component('ControlRadio', CRadio)
}

export default {
  register,
}
